import * as React from 'react';
import { Paper, Box, CardContent, CardActions, Button, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import WalmartLogo from "../Logo/walmart_marketplace_logo.jpg";
import SkypadDashboard from "../Logo/skypad_dashboard.png";

const breakpoints = [576, 768, 992, 1200]

const mq = breakpoints.map(bp => `@media (max-width: ${bp}px)`)

const StyledWalmartBox = styled(Grid)({
    padding: '20px',
});

const StyledContentBox = styled(Box)({
    flexDirection: 'column',
    padding: '0 80px',
    marginBottom: '20px',
    textAlign: 'center',
    gap: 1,
    width: { xs: '100%', md: 'fit-content' },
    overflow: 'auto',
    [mq[1]]: {
        padding: '10px',
    },
    
});

const StyledButton = styled(Button)({
    color: 'white', background: "#54B948", borderRadius: '20px', 
    fontSize: '20px !important',
    padding:'10px 40px 12px 40px',
    border: '1px solid',
    '&:hover': { background: 'white', color: '#54B948', border:'1px solid' }
});

export default function MainContent({ connectToWalmart }) {

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <div>
                    <Typography variant="h1" gutterBottom sx={{ color: "#54B948" }}>
                        Add Integrations
                    </Typography>
                    <Typography gutterBottom sx={{ fontSize: '20px', fontWeight: 400 }}>
                        Connect data from your retail partners into SKYPAD!
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={12} md={5}>
                <StyledWalmartBox >
                    <Paper elevation={3} variant="outlined" sx={{ minWidth: 275, boxShadow: 3, textAlign: 'center', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px' }}>
                        <CardContent sx={{ padding: '20px 15px 10px 15px' }}>
                            <img src={WalmartLogo} width="250" className="mb-3" />
                            <Typography variant="h3" sx={{fontSize:'20px !important'}} component="div">
                                Walmart Marketplace
                            </Typography>
                        </CardContent>
                        <CardActions sx={{ justifyContent: 'center', padding: '10px 0 20px 0px' }}>
                            <StyledButton onClick={() => connectToWalmart()}>
                                Connect
                            </StyledButton>
                        </CardActions>
                    </Paper>
                </StyledWalmartBox >
            </Grid>
            <Grid item xs={12} md={7} sx={{ margin: 'auto' }}>
                <StyledContentBox >
                    <Typography variant="h1" component="div">
                        Sell-Through Reporting Made Easy
                    </Typography>
                    <Typography component="div" sx={{ fontSize: '14px', color: '#727272', my: 2 }}>
                        SKYPAD is the ultimate omnichannel sales reporting platform - providing an automated, all-inclusive solution that is used cross-functionailty by organizations to share sales and inventory data.
                    </Typography>
                    <Typography component="div" sx={{ fontSize: '14px', color: '#727272' }}>
                        SKYPAD automatically consumes and aggregates your data!
                    </Typography>
                </StyledContentBox>
            </Grid>

            <Grid sx={{ margin: 'auto' }}>
                <img src={SkypadDashboard} width={'100%'} loading="lazy" />
            </Grid>
        </Grid>
    );
}
